<template>
  <div class="section mt-3">

    <loadingCube v-if="!loading" :loaded="loading" :loadingMessage="'LOADING HISTORIC TIMESHEETS'"></loadingCube>
    <div v-show="loading" class="row">
      <!--   <div class="col-12">-->
      <!--    <a href="/client/timesheets/submission" class="btn btngenius w-100 mb-5">Submit Timesheets</a>-->
      <!--   </div>-->

      <div class="col-12">
        <b-card header="Timesheet (Instruction) History" header-tag="h4" body-class="mb-3 pb-0 record_card_body">
          <div class="row ml-0 mr-0 mt-2">
            <div class="col-12 pl-0 pr-0">
              <div v-if="!notEmptyObject(historic_timesheets)">
                <h5 class="mb-3">You Currently have no previously submitted timesheets<br><br>Once you have submitted for a pay period you will be able to access your historic
                  submissions here.</h5>
              </div>
              <div id="accordion">
                <div class="mb-3" v-for="(k, timesheet_key) in historic_timesheets">
                  <div class=" p-0" :id="'heading' + timesheet_key">
                    <h5 class="mb-0">
                      <button class="accordionButton collapsed" data-toggle="collapse" :data-target="'#collapse' + timesheet_key" aria-expanded="false"
                              :aria-controls="'collapse' + timesheet_key">
                        <span style="display: inline-block; width: 275px; vertical-align: top;">
                            <span class="abWeekEnd">Week Starting (Mon) &nbsp;&nbsp;:&nbsp;&nbsp;</span>
                            <span class="bp_color">{{ calc_week_starting(timesheet_key) }}</span>
                            <span class="abWeekEnd">Week Ending (Fri) &nbsp;&nbsp;:&nbsp;&nbsp;</span>
                            <span>{{ calc_week_ending(timesheet_key) }}</span>
                        </span>
                        <span class="tots">
                          <span class="d-block mb-2">
                            <span class="abTotalIns">Total Instructions &nbsp;&nbsp;:&nbsp;&nbsp;</span>
                            <span>{{ k.length }}</span>
                          </span>
                          <span class="d-block">
                            <span>
                              <span class="abTotalGross">
                                <span class="font-weight-bold">Total Retention &nbsp;&nbsp;:&nbsp;&nbsp;</span>
                                <span>{{ calc_historic_retention(k) | currency }}</span>
                              </span>
                              <span class="abTotalGross ml-3">
                                <span class="font-weight-bold">Total Gross &nbsp;&nbsp;:&nbsp;&nbsp;</span>
                                <span class="bp_color">{{ calc_historic_gross(k) | currency }}</span>
                              </span>
                            </span>
                          </span>
                        </span>
                      </button>
                    </h5>
                  </div>

                  <div :id="'collapse' + timesheet_key" class="collapse" :aria-labelledby="'heading' + timesheet_key" data-parent="#accordion">
                    <div class="">
                      <div class="m-3">
                        <button class="btn orcaBtn w-100 " v-on:click="download_ts(k[0]['company_id'], timesheet_key, k[0].created_at)" :disabled="det === true">
                          <span v-if="det === true"><i class="fas fa-spinner fa-spin"></i>  Downloading... Excel copy of Timesheet</span>
                          <span v-else> Download Excel copy of Timesheet</span>
                        </button>
                      </div>

                      <div class="table-responsive">
                        <table class="table  table-striped table-sm submitted_workers c_t_sub">
                          <thead>
                          <tr>
                            <th scope="col" class="firstName">First Name</th>
                            <th scope="col" class="surname">Surname</th>
                            <th scope="col" class="payRate">Pay Rate</th>

                            <th scope="col" class="sites" v-for="(value, key, index) in setup_for_timesheet(k[0].created_at)" :style="'z-index: ' + zindexcalc(index)"
                                v-if="value !== null && key !== 'id' && key !== 'number_sites' && key !== 'company_id' && key !== 'created_at' && key !== 'updated_at' && key !==
                                'created_by' &&
                          key !== 'created_by_type' && key.includes('vat') === false">
                              <div><span>{{ value }}</span></div>
                            </th>

                            <th scope="col" class="totalHours">Total Hours</th>
                            <th scope="col" class="adjustments">Additions / Deductions<br>Description</th>
                            <th scope="col" class="totalAdditions">Total Additions</th>
                            <th scope="col" class="totalDeductions">Total Deductions</th>
                            <th scope="col" class="totalGross">Total<br>GROSS</th>
                            <th scope="col" class="totalGross">Retention<br>Amount</th>
                            <th scope="col" class="releaseRetention">Release<br>Retention</th>
                          </tr>
                          </thead>

                          <tbody>
                          <tr v-for="n in k" class="col-xl-12 pl-0 pr-0">
                            <td class="firstName">{{ n.first_name }}</td>
                            <td class="surname">{{ n.surname }}</td>
                            <td class="payRate"><span v-if="n.pay_rate !== null">{{ n.pay_rate | currency }}</span><span
                                v-else>&pound;0.00</span></td>

                            <td class="sites" v-for="i in setup_num_sites(k[0].created_at)">
                              <span v-if="n['site_' + i + '_units'] !== null">{{ n['site_' + i + '_units'] }}</span><span v-else>0</span>
                            </td>

                            <td class="totalHours">{{ n.total_units }}</td>
                            <td class="adjustments">{{ n.adjustment_description }}</td>
                            <td class="totalAdditions"><span v-if="n.addition_amount !== null">{{ n.addition_amount | currency }}</span><span
                                v-else> &pound;0.00</span></td>
                            <td class="totalDeductions"><span v-if="n.deduction_amount !== null">{{ n.deduction_amount | currency }}</span><span
                                v-else> &pound;0.00</span></td>
                            <td class="totalGross">{{ n.gross | currency }}</td>
                            <td class="totalGross">{{ n.retention_amount | currency }}</td>
                            <td class="releaseRetention" v-if="n.release_retention === '1'"><span>Yes</span></td>
                            <td class="releaseRetention" v-if="n.release_retention === '0'"><span>No</span></td>
                          </tr>
                          </tbody>
                        </table>
                      </div>

                      <div class="mt-4">
                        <div class="table-responsive">
                          <table class="table table-striped table-sm running_site_totals c_t_sub">
                            <thead>
                            <tr>
                              <th scope="col" class="firstName"></th>
                              <th scope="col" class="sites" :style="'z-index: ' + zindexcalc(index)"
                                  v-for="(value, key, index) in setup_for_timesheet(k[0].created_at)"
                                  v-if="value !== null && key !== 'id' && key !== 'number_sites' && key !== 'company_id' && key !== 'created_at' && key !== 'updated_at' && key !==
                                  'created_by'
                            && key !== 'created_by_type' && key.includes('vat') === false">
                                <div><span>{{ value }}</span></div>
                              </th>
                              <th scope="col" class="text-center">Total Units</th>
                              <th scope="col" class="text-center">Total Additions</th>
                              <th scope="col" class="text-center">Total Deductions</th>
                              <th scope="col" class="totalGross text-center">Total GROSS</th>
                              <th scope="col" class="totalGross text-center">Total Retention</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr class="col-xl-12 pl-0 pr-0">
                              <td class="firstName font-weight-bold">Site Totals</td>
                              <td class="sites" v-for="i in setup_num_sites(k[0].created_at)">{{ calc_historic_site_totals(i, k) | currency }}</td>
                              <td>-</td>
                              <td>{{ calc_historic_additions(k) | currency }}</td>
                              <td>{{ calc_historic_deductions(k) | currency }}</td>
                              <td class="text-center">{{ calc_historic_gross(k) | currency }}</td>
                              <td class="text-center">{{ calc_historic_retention(k) | currency }}</td>
                            </tr>
                            <tr class="col-xl-12 pl-0 pr-0">
                              <td class="firstName font-weight-bold">Site Total Units</td>
                              <td class="sites" v-for="i in setup_num_sites(k[0].created_at)">{{ calc_historic_site_unit_totals(i, k) }}</td>
                              <td>{{ calc_historic_unit_totals(k) }}</td>
                              <td>-</td>
                              <td>-</td>
                              <td>-</td>
                              <td class="text-center">-</td>
                              <td class="text-center">-</td>
                            </tr>
                            </tbody>
                          </table>
                        </div>

                        <hr style="  border: none;border-bottom: 6px double #e6007e;margin-bottom: 10px;margin-top: 30px;">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </b-card>

      </div>
    </div>
  </div>
</template>
<script>

import loadingCube from "loaders/record_loader";
import moment from "moment-mini";

export default {
  name: "client_timesheets",
  props: ['timesheet_setup',],
  components: {loadingCube},
  data() {
    return {
      loading: false,
      det: false,

      client_name: "",

      historic_timesheets: [],
      historic_setups: []
    }
  },
  created() {
    this.load_template().then(() => this.loading = true);
  },
  methods: {
    load_template() {
      return new Promise(resolve => {
        axios.get(this.crmApiPath + 'contact/' + this.$store.state.auth.me.contact_id + '/company/show').then(company => {
          this.client_name = company.data.company_name;
          axios.post(this.crmApiPath + 'client/timesheets/get/historic', {
            contact_id: this.$store.state.auth.me.contact_id,
            company_id: company.data.id
          }).then(response => {
            this.historic_timesheets = response.data['timesheets'];
            this.historic_setups = response.data['setups'];
            resolve();
          });
        });
      });
    },
    download_ts(client_id, week_start, created_date) {
      this.det = true;
      let start_date = moment.utc(week_start).format('YYYY-MM-DD 00:00:00');
      // let end_date = moment(week_start).add(6, 'days').format('YYYY-MM-DD 23:59:59');
      let end_date = moment.utc(created_date).format('YYYY-MM-DD 23:59:59');

      let sd = moment.utc(week_start).format('DD-MM-YYYY');
      let ed = moment.utc(week_start).endOf('week').add(1, 'days').format('DD-MM-YYYY');

      axios.get(this.crmApiPath + 'client/timesheets/download/historic', {
        responseType: 'arraybuffer',
        params: {
          company_id: client_id,
          company_name: this.client_name,
          start_date: moment.utc(week_start).format('DD-MM-YYYY'),
          end_date: end_date
        }
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', this.client_name + '-Genius-Timesheet-' + sd + '-to-' + ed + '.xlsx');
        document.body.appendChild(link);
        link.click();
        link.remove();
        this.det = false;
      })
    },
    calc_week_starting(date) {
      return moment.utc(date).format('DD-MM-Y');
    },
    calc_week_ending(date) {
      return moment.utc(date).add(5, 'days').format('DD-MM-Y');
    },
    zindexcalc(index) {
      return 80 - index;
    },

    setup_for_timesheet(week_end_date) {
      let temp_historic_setup_keys = Object.keys(this.historic_setups);
      // let end_of_week = moment(week_end_date, "YYYY-MM-DD").add(6, 'days').format('YYYY-MM-DD');
      let end_of_week = moment.utc(week_end_date).format('YYYY-MM-DD');
      let temp = [];
      for (let i = 0; i < temp_historic_setup_keys.length; i++) {
        if (temp_historic_setup_keys[i] <= end_of_week) {
          temp.push(temp_historic_setup_keys[i])
        }
      }
      if (temp.length !== 0) {
        return this.historic_setups[temp.slice(-1)[0]].slice(-1)[0];
      }
    },
    setup_num_sites(week_end_date) {
      let temp_historic_setup_keys = Object.keys(this.historic_setups);
      // let end_of_week = moment(week_end_date, "YYYY-MM-DD").add(6, 'days').format('YYYY-MM-DD');
      let end_of_week = moment.utc(week_end_date).format('YYYY-MM-DD');
      let temp = [];
      for (let i = 0; i < temp_historic_setup_keys.length; i++) {
        if (temp_historic_setup_keys[i] <= end_of_week) {
          temp.push(temp_historic_setup_keys[i])
        }
      }
      if (temp.length !== 0) {
        return this.historic_setups[temp.slice(-1)[0]].slice(-1)[0]['number_sites'];
      }
    },

    calc_historic_site_totals(site, k) {
      let temp_total = 0;

      for (let w in k) {
        if (k[w]['site_' + [site] + '_units'] !== null && k[w]['site_' + [site] + '_units'] !== '') {
          temp_total += (parseFloat(k[w]['site_' + [site] + '_units']) * parseFloat(k[w].pay_rate));
        }
      }
      return temp_total;
    },
    calc_historic_site_unit_totals(site, k) {
      let temp_total = 0;
      for (let w in k) {
        if (k[w]['site_' + [site] + '_units'] !== null && k[w]['site_' + [site] + '_units'] !== '') {
          temp_total += parseFloat(k[w]['site_' + [site] + '_units']);
        }
      }
      return temp_total;
    },

    calc_historic_unit_totals(k) {
      let num_sites = this.setup_num_sites(k[0].created_at) + 1;
      let temp_total = 0;
      for (let i = 1; i < num_sites; i++) {
        for (let w in k) {
          if (k[w]['site_' + [i] + '_units'] !== null && k[w]['site_' + [i] + '_units'] !== '') {
            temp_total += parseFloat(k[w]['site_' + [i] + '_units']);
          }
        }
      }
      return temp_total;
    },

    calc_historic_gross(k) {
      let temp_gross = 0;
      for (let i in k) {
        temp_gross += parseFloat(k[i].gross)
      }
      return temp_gross
    },
    calc_historic_retention(k) {
      let temp_retention = 0;
      for (let i in k) {
        temp_retention += parseFloat(k[i].retention_amount)
      }
      return temp_retention
    },

    calc_historic_additions(k) {
      let temp_additions = 0;
      for (let i in k) {
        temp_additions += parseFloat(k[i].addition_amount)
      }
      return temp_additions
    },
    calc_historic_deductions(k) {
      let temp_deductions = 0;
      for (let i in k) {
        temp_deductions += parseFloat(k[i].deduction_amount)
      }
      return temp_deductions
    },
  },
}
</script>
<style lang="scss">
.accordionButton {
  border:           none;
  background-color: lighten($bc_5, 10%);
  padding:          10px 20px;
  width:            100%;
  text-align:       left;
  color:            $bc_3;

  &:hover, &:focus, &:active {
    background: $bc_3;
    cursor:     pointer;
    color:      $white;
    outline:    0;
  }

  &[aria-expanded="true"] {
    background: $bc_4;
    color:      $white;
  }

  .abWeekEnd {
    display:     inline-block;
    width:       171px;
    font-weight: bold;
  }

  span {
    font-size: 0.85rem;
  }

  .tots {
    display:    inline-block;
    width:      calc(100% - 300px);
    text-align: right;
  }

  .abTotalIns {
    font-weight: bold;
  }

  .abWeekEnd, .abTotalIns, .abTotalGross {

    //display:   inline-block;
    //width:     350px;

  }

  .abTotalIns, .abTotalGross {
    //font-size:  0.85rem;
    //float:      right;
    //text-align: right;

    span {
      //display:    inline-block;
      //width:      150px;
      //text-align: left;
    }
  }
}

.week_beg {
  vertical-align: top;
  width:          370px;
  display:        inline-block;
  line-height:    38px;
}

.submission_week {
  vertical-align: top;
  display:        inline-block;
  width:          calc(100% - 400px);
  z-index:        999;
}

#certifyText {
  font-size:   0.75em;
  line-height: 15px;
  display:     inline-block;
  width:       calc(100% - 45px);
  float:       left;
}

input[type="number"]::-webkit-outer-spin-button, input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin:             0;
}

input[type="number"] {
  -moz-appearance: textfield;
}

.table.c_t_sub {

  &.table-striped tbody tr:nth-of-type(odd) {
    td {
      background-color: rgba(lighten($bc_4, 45%), 1);
    }
  }

  &.table-striped tbody tr:nth-of-type(even) {
    td {
      background-color: rgba(lighten($bc_4, 35%), 1);
    }
  }

  tr {
    &.gang_leader {
      td {
        background-color: lighten(#FFD734, 25%) !important;
      }

    }
  }

  thead {
    background-color: rgba(lighten($bc_4, 35%), 1) !important;

    th {
      position:           sticky;
      top:                0;
      background:         $white !important;
      z-index:            5;
      border:             none;
      -webkit-box-shadow: 0px 1px 0px 0px rgba($bc_3, 0.75);
      -moz-box-shadow:    0px 1px 0px 0px rgba($bc_3, 0.75);
      box-shadow:         0px 1px 0px 0px rgba($bc_3, 0.75);

      &.sites {
        height:         140px;
        white-space:    nowrap;
        vertical-align: inherit;
      }

      &.sites > div {
        transform: translate(10px, 50px) rotate(315deg);
        width:     30px;
      }

      &.sites > div > span {
        padding: 0 5px;
      }
    }
  }

  td {
    vertical-align: middle;
    position:       relative;
    height:         45px;
    line-height:    15px;

    input, textarea {
      border:  1px solid darken($bc_4, 5%);
      display: block;
      height:  100%;
      width:   100%;
    }
  }

  .firstName, .surname {
    min-width:        150px;
    position:         sticky;
    left:             0;
    z-index:          85;
    background-color: rgba(lighten($bc_4, 35%), 1);
  }

  .surname {
    left: 150px;
  }

  .payRate, .totalAdditions, .totalDeductions {
    max-width:        110px;
    min-width:        110px;
    background-color: rgba(lighten($bc_4, 35%), 1);
  }

  .sites {
    max-width:        60px;
    min-width:        60px;
    background-color: rgba(lighten($bc_4, 35%), 1);
  }

  .totalHours {
    text-align:       center;
    min-width:        100px;
    background-color: rgba(lighten($bc_4, 35%), 1);
  }

  .adjustments {
    min-width:        250px;
    background-color: rgba(lighten($bc_4, 35%), 1);
  }

  .totalGross {
    min-width:        120px;
    text-align:       center;
    background-color: rgba(lighten($bc_4, 35%), 1);
  }

  .backNextWeek {
    max-width:        75px;
    min-width:        75px;
    position:         sticky;
    left:             0;
    z-index:          30;
    //background: transparent;
    text-align:       center;
    background-color: rgba(lighten($bc_4, 35%), 1);
  }

  .releaseRetention {
    max-width:        80px;
    min-width:        80px;
    position:         sticky;
    left:             0;
    z-index:          30;
    //background: transparent;
    text-align:       center;
    background-color: rgba(lighten($bc_4, 35%), 1);
  }

  .submitPayroll {
    max-width:        75px;
    min-width:        75px;
    text-align:       center;
    background-color: rgba(lighten($bc_4, 35%), 1);
  }

  td {
    &.submitPayroll {
      font-size: 1.25rem;
    }

    &.firstName, &.surname {
      z-index: 28;
    }

    &.payRate, &.sites, &.adjustments, &.totalAdditions, &.totalDeductions {
      padding: 0;
    }

    &.backNextWeek {
      font-size: 1.25rem;
      z-index:   27;
    }

    &.releaseRetention {
      font-size: 1.25rem;
      z-index:   27;
    }
  }

  &.submitted_workers {
    span {
      font-size: 0.9rem;
    }

    td {
      &.firstName, &.surname {
        z-index: 28;
      }

      &.payRate, &.sites, &.adjustments, &.totalAdditions, &.totalDeductions {
        padding: 0.3rem;
      }

      &.sites {
        text-align: center;
      }

      &.backNextWeek {
        font-size: 1.25rem;
        z-index:   28;
      }

      &.releaseRetention {
        font-size: 1.25rem;
        z-index:   28;
      }
    }
  }
}

.running_site_totals, .submitted_site_totals {

  td {
    &.sites {
      /*width: 150px;*/
      max-width: 150px;
      min-width: 90px;
    }
  }

}
</style>
